module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [_c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.loading,
      "size": 100
    }
  }, [_c('FormInviteWrapper', [(_vm.errors) ? _c('AppHeading', {
    attrs: {
      "mod": "center"
    }
  }, [_vm._v(_vm._s(_vm.errors))]) : [_c('AppText', [_vm._v("Здравствуйте "), _c('strong', [_vm._v(_vm._s(_vm.invitedName))]), _vm._v(". Для регистрации вам нужно задать пароль от нового аккаунта. Пароль должен содержать более шести символов.")]), _c('InviteForm', [_c('FormInput', {
    attrs: {
      "slot": "inputs",
      "label": "Пароль",
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "Введите пароль",
      "error-text": "Не менее 6 символов",
      "required": true,
      "v": _vm.$v.passwords.newPassword
    },
    slot: "inputs",
    model: {
      value: (_vm.passwords.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "newPassword", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "passwords.newPassword"
    }
  }), _c('FormInput', {
    attrs: {
      "slot": "inputs",
      "label": "Повтор пароля",
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "Введите пароль еще раз",
      "error-text": "Пароли не совпадают",
      "required": true,
      "v": _vm.$v.passwords.comparePassword
    },
    slot: "inputs",
    model: {
      value: (_vm.passwords.comparePassword),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "comparePassword", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "passwords.comparePassword"
    }
  }), _c('Button', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Отправить")])], 1)]], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7606f9ad","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/invite/Invite.vue
// module id = 16de5574a8317d491379
// module chunks = 22